import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { VerificationDataType } from '../../models/profileSettings/Verification.model';
import {
  ErrorHttpResponse,
  SuccessHttpResponse,
  HttpConfig,
} from '../../models/https';
import useHttps from '../useHttps';
import useGetData from '../settings/useGetData';

const useCreateVerification = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetData();

  const onCreateVerificationError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while adding verification data'
    );
  };

  const onCreateVerificationSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    if (message) {
      toast.success(message);
    } else {
      toast.success('successful');
    }
    getUserData();
  };

  // const createVerification = (data: VerificationDataType) => {
  const createVerification = async (data: VerificationDataType) => {
    const formData = new FormData();

    formData.append('license', data.license);
    formData.append('facilityId', data.facilityId);
    formData.append('cacCertificate', data.cacCertificate);

    const url: HttpConfig = {
      url: `auth-service/institution/verification-documents`,
      method: 'patch',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    request(
      url,
      onCreateVerificationSuccess,
      setLoading,
      onCreateVerificationError
    );
  };

  return { createVerification, loading };
};

export default useCreateVerification;
